module.exports = __webpack_public_path__ + "img/card_informe_eden_personal.01c81448.svg";